import React, { useState } from "react";
import CreditMonitoring from "../components/ui/CreditMonitoring";
import General from "../components/ui/General";
import Legal from "../components/ui/Legal";
import Settings from "../components/ui/Settings";
import Support from "../components/ui/Support";

function MyAccount() {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      title: "General",
      content: <General />,
    },
    {
      title: "Settings",
      content: <Settings />,
    },
    {
      title: "Credit Monitoring",
      content: <CreditMonitoring />,
    },
    {
      title: "Support",
      content: <Support />,
    },
    {
      title: "Legal",
      content: <Legal />,
    },
  ];

  return (
    <div className="page_overflow">
      <section className="repair_credit">
        <div className="container">
          <div className="section_title">
            <h2>My Account</h2>
          </div>
          <div className="tabs-container">
      {/* Render tab titles */}
      <div className="tabs">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`tab ${activeTab === index ? "active" : ""}`}
            onClick={() => setActiveTab(index)}
          >
            {tab.title}
          </button>
        ))}
      </div>

      {/* Render active tab content */}
      <div className="tab-content">{tabs[activeTab].content}</div>
    </div>
        </div>
      </section>
    </div>
  );
}

export default MyAccount;
